import { render, staticRenderFns } from "./CloudCustomerPayway.vue?vue&type=template&id=224a6b64&"
import script from "./CloudCustomerPayway.vue?vue&type=script&lang=js&"
export * from "./CloudCustomerPayway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports